"use client"

import Link from "next/link"
import { Home, Calendar, Tag, Receipt, Bell } from "lucide-react"
import Image from "next/image"

import { Sheet, SheetContent, SheetHeader } from "@/components/ui/sheet"
import { useCurrentBranch } from "@/context/current-branch-provider"
import { BranchEvent, BranchPromotion } from "@/types/popadvise"
import { DialogTitle } from "@/components/ui/dialog"

export default function NavigationMenu({ open, setOpen, promotions, events }: {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    promotions: BranchPromotion[]
    events: BranchEvent[]
}) {

    const { brand } = useCurrentBranch()

    return (
        <div>
            <Sheet open={open} onOpenChange={setOpen}>
                <SheetContent side="left" className="p-0">
                    <SheetHeader className="flex flex-row items-center justify-between border-b p-4">
                        <DialogTitle className="hidden" />
                        <div className="flex items-center">
                            <Image
                                src={brand.logo.url}
                                alt="logo" width={32}
                                height={32}
                                className="object-cover rounded-full drop-shadow-lg w-8 h-8"
                            />
                        </div>
                        {/* <Button variant="ghost" size="icon" onClick={() => setOpen(false)}>
                            <X className="h-5 w-5" />
                            <span className="sr-only">Cerrar menú</span>
                        </Button> */}
                    </SheetHeader>
                    <nav className="flex flex-col p-4">
                        <ul className="space-y-3">
                            <li>
                                <Link
                                    href="/"
                                    className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors"
                                    onClick={() => setOpen(false)}
                                >
                                    <Home className="h-5 w-5" />
                                    Inicio
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="/reservations"
                                    className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors"
                                    onClick={() => setOpen(false)}
                                >
                                    <Calendar className="h-5 w-5" />
                                    Reservaciones
                                </Link>
                            </li>
                            {
                                events.length > 0 && (
                                    <li>
                                        <Link
                                            href="#events"
                                            className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors"
                                            onClick={() => setOpen(false)}
                                        >
                                            <Bell className="h-5 w-5" />
                                            Eventos
                                        </Link>
                                    </li>
                                )
                            }
                            {
                                promotions.length > 0 && (
                                    <li>
                                        <Link
                                            href="#promotions"
                                            className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors"
                                            onClick={() => setOpen(false)}
                                        >
                                            <Tag className="h-5 w-5" />
                                            Promociones
                                        </Link>
                                    </li>
                                )
                            }
                            {
                                brand.billingUrl && (
                                    <li>
                                        <Link
                                            target="_blank"
                                            href={brand.billingUrl}
                                            className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground transition-colors"
                                            onClick={() => setOpen(false)}
                                        >
                                            <Receipt className="h-5 w-5" />
                                            Facturación
                                        </Link>
                                    </li>
                                )
                            }
                        </ul>
                    </nav>
                </SheetContent>
            </Sheet>
        </div>
    )
}
